import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Sidebar from 'containers/sidebar'
import { isPMOrAdmin } from 'shared/helpers/user'
import { localizedTranslate, localizedDateFormatter, getUserTimeZone } from 'assets/localization'
import Table from 'components/userManagement/table-component'
import { fetcAllhUserDetails, updateAllowContactByEmail } from 'store/user/userActions'
import { Spinner } from '@blueprintjs/core'

import 'less/user-management.less'

const UserManagement = (props) => {

    let linksArray = [
        {
            display: 'Projects',
            icon: 'im-ss-inboxes',
            path: '/projects',
        }, {
            display: 'Interviews',
            icon: 'im-ic-interview',
            path: '/interviews',
        }, {
            display: isPMOrAdmin ? 'All Moderator Calendar' : 'My Schedule',
            icon: isPMOrAdmin ? 'im-calendar-all-moderator' : 'im-calendar',
            path: '/moderator/schedule',
            className: isPMOrAdmin ? 'all-moderator-schedule' : '',
        }, {
            display: 'Moderator Management',
            icon: 'im-user2',
            path: '/moderatorManagement/schedule',
            className: 'all-moderator-schedule',
        },
        {
            display: 'User Management',
            path: '/userManagement',
            className: 'user-management',
        }
        , {
            display: 'Profile',
            icon: 'im-ss-user',
            path: '/profile',
        }]

    useEffect(() => { props.fetcAllhUserDetails() }, [])

    return (
        <div className="top-level-content-wrap">
            <Sidebar
                links={linksArray}
            />
            <div id="user-management" className="top-level-content">
                <div className="topbar">
                    <div className="user-management-header">
                        <div className='topbar-header'>
                            <h4>User Management</h4>
                            <div className='line'></div>
                            <h6 className='sub-header'>{'Admin Tools > User Management'}</h6>
                        </div>
                    </div>
                </div>
                {props.isLoading ? <Spinner intent="primary" /> :
                    <div className="user-management-container">
                        <Table {...props}></Table>
                    </div>
                }
            </div>
        </div>
    )
}

const mapState = state => ({
    t: localizedTranslate('en', state.translations.en_us),
    usersDetails: state.user.usersDetails,
    isLoading: state.user.isLoading,
    contactPreferencesModal: state.ui.contactPreferencesModal,
    isUpdating: state.user.isUpdating,
    formatDate: localizedDateFormatter('en', getUserTimeZone(state)),
    pmUser: state.user
})

const mapDispatch = {
    openContactPreferencesModal: (payload) => ({ type: 'OPEN_CONTACT_PREFERENCES_MODAL', payload }),
    closeContactPreferencesModal: (payload) => ({ type: 'CLOSE_CONTACT_PREFERENCES_MODAL', payload }),
    fetcAllhUserDetails,
    updateAllowContactByEmail,
    showSnackbarMessageError: message => ({
        type: 'SHOW_MESSAGE',
        payload: {
          message: message,
          className: 'copy-screeners-snackbar',
        },
      }),
      hideSnackbarMessage: () => ({ type: 'HIDE_MESSAGE' })
}

export default connect(mapState, mapDispatch)(UserManagement)
